import ICharacter from '#/types/characters';
import {
  CharacterDetailsActionType,
  TCharacterDetailsActions,
} from '../actions/characterDetails';

interface IState {
  character: ICharacter | undefined;
}

const initialState: IState = {
  character: undefined,
};

const characterDetailsReducer = (
  state = initialState,
  { type, payload }: TCharacterDetailsActions
): IState => {
  switch (type) {
    case CharacterDetailsActionType.CHARACTER_DETAILS_SET_CHARACTER_DETAILS:
      return { ...state, character: payload };

    default:
      return state;
  }
};

export default characterDetailsReducer;
